/*eslint-disable*/
import clsx from "clsx";
import styles from "./style.module.scss";

type Props = {
  children?: React.ReactNode;
  className?: string;
  style?: any;
  ref?: any;
};
export default function Table({ children, className, ref, style }: Props) {
  return (
    <div ref={ref} style={style} className={clsx(styles.table, className)}>
      {children}
    </div>
  );
}
